import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import PropTypes from 'prop-types';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './datepicker-styles.css';
import { Label } from 'semantic-ui-react';
import MonthYearElement from './MonthYearElement';
import { getTranslatedPlaceholder } from '../../utils';

class AdvancedDatePickerWrapper extends Component {
  state = {
    hasFocus: false
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      hasFocus: false
    };
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (JSON.stringify(prevProps.value) !== JSON.stringify(value)) this.updateValue(value);
  }

  updateValue = date => {
    this.setState({ value: date });
  };

  handleChange(date, name) {
    this.props.setFieldValue(this.props.name, date);
    this.updateValue(date);
    this.props.onChange();
  }

  renderCustomLabel(customLabel) {
    if (customLabel) {
      return <Label content={customLabel} />;
    }
    return null;
  }

  render() {
    const {
      disabled,
      name,
      customLabel,
      renderDefaultButtons,
      className,
      parentClassName,
      openDirection,
      numberOfMonths,
      renderYearElement,
      label,
      placeholder,
			...restProps
    } = this.props;
    const { hasFocus, value } = this.state;
    const { value: v, setFieldValue, onChange, ...restToPassToDate } = restProps; //exclude fields, otherwise throws warnings

		const optionalPropsToPass = {};
		if (renderYearElement) optionalPropsToPass.renderMonthElement = MonthYearElement;

    //hidding default week days is a work around because otherwise they appear above dropdown, even if adding zIndexes
    return (
      <div style={{ display: 'flex' }} className={parentClassName}>
        {this.renderCustomLabel(customLabel)}
        <div className={className + (renderYearElement ? ' hideDefaultWeekDays' : '')}>
          <SingleDatePicker
						{...restToPassToDate}
						{...optionalPropsToPass}
            block
            noBorder
            disabled={disabled}
            isOutsideRange={() => false}
            date={value}
            onDateChange={date => this.handleChange(date, name)}
            focused={hasFocus}
            onFocusChange={({ focused }) => this.setState({ hasFocus: focused })}
            displayFormat="DD-MM-YYYY"
            placeholder={getTranslatedPlaceholder(label, placeholder)}
            id={name}
            openDirection={openDirection}
            numberOfMonths={numberOfMonths}
          />
        </div>
        {renderDefaultButtons}
      </div>
    );
  }
}

AdvancedDatePickerWrapper.propTypes = {
  disabled: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};

AdvancedDatePickerWrapper.defaultProps = {
  disabled: false,
  noBorder: false,
  onChange: () => {},
  openDirection: 'down',
  renderYearElement: true,
  numberOfMonths: 1,
  placeholder: 'DD-MM-YYYY'
};

export default AdvancedDatePickerWrapper;
